/* eslint-disable import/prefer-default-export */
export enum UPDATING_TYPE {
  UPDATING,
  SYNCING,
}

export type UpdatingType = UPDATING_TYPE | false;
